// extracted by mini-css-extract-plugin
module.exports = {"card":"hotel_card_card__31KCG","card-content":"hotel_card_card-content__C0JlY","card-content-no_data":"hotel_card_card-content-no_data__1Ip9d"};